// src/constants/statusMeta.js
//
// Single source of truth for status metadata.
// CSS variables + .status-badge .status--* classes live in GlobalStyles.css.
//
// Prefer className approach; inline-style helpers (color/bg) are for pill buttons.

// ── Task / Line Operation ─────────────────────────────────────────────────────
export const TASK_STATUS_META = {
  NEW:         { label: 'Novo',         cls: 'status--new',         color: '#3f6212', bg: '#ecfccb' },
  IN_REVIEW:   { label: 'Em Análise',   cls: 'status--in_review',   color: '#7c3aed', bg: '#ede9fe' },
  IN_PROGRESS: { label: 'Em Curso',     cls: 'status--in_progress', color: '#1d4ed8', bg: '#dbeafe' },
  ON_HOLD:     { label: 'Em Espera',    cls: 'status--on_hold',     color: '#d97706', bg: '#fef3c7' },
  COMPLETED:   { label: 'Concluído',    cls: 'status--completed',   color: '#166534', bg: '#dcfce7' },
  CANCELLED:   { label: 'Cancelado',    cls: 'status--cancelled',   color: '#dc2626', bg: '#fee2e2' },
};
export const getTaskStatusMeta  = (s) => TASK_STATUS_META[s]  || TASK_STATUS_META.NEW;
export const getTaskStatusClass = (s) => getTaskStatusMeta(s).cls;
export const getTaskStatusLabel = (s) => getTaskStatusMeta(s).label;

// ── Action Plan (plan-level) ──────────────────────────────────────────────────
// Same status keys as tasks — standardised palette
export const AP_STATUS_META = {
  NEW:         { label: 'Novo',         cls: 'status--new',         color: '#3f6212', bg: '#ecfccb' },
  IN_REVIEW:   { label: 'Em Análise',   cls: 'status--in_review',   color: '#7c3aed', bg: '#ede9fe' },
  IN_PROGRESS: { label: 'Em Curso',     cls: 'status--in_progress', color: '#1d4ed8', bg: '#dbeafe' },
  ON_HOLD:     { label: 'Em Espera',    cls: 'status--on_hold',     color: '#d97706', bg: '#fef3c7' },
  COMPLETED:   { label: 'Concluído',    cls: 'status--completed',   color: '#166534', bg: '#dcfce7' },
  CANCELLED:   { label: 'Cancelado',    cls: 'status--cancelled',   color: '#dc2626', bg: '#fee2e2' },
};
export const getApStatusMeta  = (s) => AP_STATUS_META[s]  || AP_STATUS_META.NEW;
export const getApStatusClass = (s) => getApStatusMeta(s).cls;
export const getApStatusLabel = (s) => getApStatusMeta(s).label;

// ── Action Plan sub-task (action-level) ───────────────────────────────────────
// Same palette — 'Concluída' (feminine) for sub-task completed state
export const ACTION_STATUS_META = {
  NEW:         { label: 'Novo',         cls: 'status--new',         color: '#3f6212', bg: '#ecfccb' },
  IN_REVIEW:   { label: 'Em Análise',   cls: 'status--in_review',   color: '#7c3aed', bg: '#ede9fe' },
  IN_PROGRESS: { label: 'Em Curso',     cls: 'status--in_progress', color: '#1d4ed8', bg: '#dbeafe' },
  ON_HOLD:     { label: 'Em Espera',    cls: 'status--on_hold',     color: '#d97706', bg: '#fef3c7' },
  COMPLETED:   { label: 'Concluída',    cls: 'status--completed',   color: '#166534', bg: '#dcfce7' },
  CANCELLED:   { label: 'Cancelada',    cls: 'status--cancelled',   color: '#dc2626', bg: '#fee2e2' },
};
export const getActionStatusMeta  = (s) => ACTION_STATUS_META[s]  || ACTION_STATUS_META.NEW;
export const getActionStatusClass = (s) => getActionStatusMeta(s).cls;
export const getActionStatusLabel = (s) => getActionStatusMeta(s).label;

// ── Sample Order ──────────────────────────────────────────────────────────────
export const ORDER_STATUS_META = {
  OPEN:            { label: 'Aberto',          cls: 'status--open',          color: '#1d4ed8', bg: '#dbeafe' },
  RELEASED:        { label: 'Liberto',         cls: 'status--released',      color: '#7c3aed', bg: '#ede9fe' },
  //'IN PROGRESS':   { label: 'Em Curso',        cls: 'status--in_progress',   color: '#1d4ed8', bg: '#dbeafe' },
  //'SENT CUSTOMER': { label: 'Enviado Cliente', cls: 'status--sent_customer', color: '#0f766e', bg: '#e0f2f1' },
  ON_HOLD:     { label: 'Em Espera',    cls: 'status--on_hold',     color: '#d97706', bg: '#fef3c7' },
  CLOSED:          { label: 'Fechado',         cls: 'status--closed',        color: '#166534', bg: '#dcfce7' },
  CANCELLED:       { label: 'Cancelado',       cls: 'status--cancelled',     color: '#dc2626', bg: '#fee2e2' },
};
export const getOrderStatusMeta  = (s) => ORDER_STATUS_META[s]  || ORDER_STATUS_META.OPEN;
export const getOrderStatusClass = (s) => getOrderStatusMeta(s).cls;
export const getOrderStatusLabel = (s) => getOrderStatusMeta(s).label;

// ── Inline style helper for interactive pill buttons ─────────────────────────
export const statusPillStyle = (meta, active = true) => active
  ? { background: meta.bg, color: meta.color, borderColor: meta.color, fontWeight: 700 }
  : { background: 'white', color: 'var(--gray-600)', borderColor: 'var(--gray-200)', fontWeight: 400 };